import { render, staticRenderFns } from "./EngagementInteractionList.vue?vue&type=template&id=81b4b7a8&scoped=true&"
import script from "./EngagementInteractionList.vue?vue&type=script&lang=ts&"
export * from "./EngagementInteractionList.vue?vue&type=script&lang=ts&"
import style0 from "./EngagementInteractionList.vue?vue&type=style&index=0&id=81b4b7a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b4b7a8",
  null
  
)

export default component.exports